export async function chatWithServerAI(messages, context) {
  const serverUrl = window.global?.server_url || "";
  // Trim trailing slash if serverUrl has it, to avoid double slashes
  const baseUrl = serverUrl.endsWith("/") ? serverUrl : `${serverUrl}/`;
  const API_URL = `${baseUrl}api/v1/ai/copilot`;
  
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
  };
  
  if (token) {
    headers["Authorization"] = `Token ${token}`;
  }

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        messages: messages,
        context: {
          relevantContext: context?.relevantContext || "",
          cursorLine: context?.cursorLine || null,
          selectedText: context?.selectedText || ""
        }
      }),
    });

    if (!response.ok) {
      let errorMessage = "AI Server Error";
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorData.message || errorMessage;
      } catch (e) {
        // Fallback if response is not JSON
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    // Support multiple common response keys for robustness
    const reply = data.response || data.content || data.reply;
    if (!reply) {
      throw new Error("Invalid response format from AI server");
    }
    return reply;
  } catch (error) {
    console.error("AI Service Error:", error);
    throw error;
  }
}

